import { Injectable } from '@angular/core';
import { ParentAPIService } from '../parent.api.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiValidation } from 'src/app/model/api/api-validation';
import { CrystalclearToolsBackUrl } from '../config/crystalclear-tools-back-url';
import { CrystalclearBackUrl } from '../config/crystalclear-back-url';
import { ConversionRate } from 'src/app/model/hogo-conversion-rate';
import { Calculate } from 'src/app/model/hogo-calculate';
import { CalculateRequest } from 'src/app/model/hogo-calculate-request';

@Injectable({
  providedIn: 'root'
})
export class CalculationService extends ParentAPIService{

  constructor(http: HttpClient) {
      super(http);
    }

  public calculate(heatOilAveragePrice: number, gasOilPrices: number[], conversionRate: number) : Observable<Calculate> {
    const request = new CalculateRequest();
    request.heatOilAveragePrice = heatOilAveragePrice;
    request.gasOilPrices = gasOilPrices;
    request.conversionRate = conversionRate;
    return this.post<Calculate>(CrystalclearBackUrl.HOGO_CALCULATE, request)
  }

  public calculateGasoilAverageprice(prices: number[]) {
    const totalPrices = prices.reduce((acc, b)=> acc + b, 0);
    const averagePrice = totalPrices / prices.length;
    const normalizedAveragePrice = Math.ceil(averagePrice * 4) / 4; //returns the average price with a step of 0.25
    return normalizedAveragePrice;
  }

  public getConversionRate(): Observable<ConversionRate> {
    return this.get<ConversionRate>(CrystalclearBackUrl.HOGO_CONVERSION_RATE)
  }
}
